import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlane: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paper-plane, send"><path d="M9.25 12H6.5M3.5 3.5L20.25 12L3.5 20.5L6 12L3.5 3.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPaperPlane;
